// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"5029dbc9820d9cfbeca9","245":"64760c487ce26fc98e26","452":"496242a89183933bfcef","453":"7b85c56fc5f417d041c0"}[chunkId] + ".js";
};